export const isRangeQuantityRule = rule =>
  rule?.entity === 'PRODUCT_ID' && rule?.details?.calculation_type === 'RANGE_QUANTITY'

export const hasRangeQuantityRule = (rules = []) => rules.some(isRangeQuantityRule)

export const hasNonSetPriceActions = (actions = []) => actions.some(action => action?.type !== 'SET_PRICE')

export const filterSetPriceActions = (actions = []) => actions.filter(action => action?.type === 'SET_PRICE')

export const hasInvalidRangeQuantityActionMix = (rules = [], actions = []) =>
  hasRangeQuantityRule(rules) && hasNonSetPriceActions(actions)
